import { useMediaQuery, Box, useScrollTrigger, Slide } from "@mui/material";
import React, { ReactNode } from "react";
import { Outlet } from "react-router";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { css, useTheme } from "@emotion/react";
import { useAppLayout } from "@providers/AppLayoutProvider";
import { AppSidebar } from "@components/common";
import { UserWithType } from "@api";
import { Quickbar } from "../Quickbar";

const Backdrop = styled(motion.div)`
  display: flex;
  flex-direction: column;
`;

const Content = styled("div")<{
  collapsed?: boolean;
  isMobile: boolean;
}>`
  ${({ collapsed, isMobile }) => {
    if (isMobile)
      return css`
        padding-left: 0;
      `;

    return collapsed
      ? css`
          padding-left: 55px;
        `
      : css`
          padding-left: 300px;
        `;
  }}
`;

function HideOnScroll(props: { children: React.ReactElement }) {
  const { children } = props;
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="up" in={!trigger}>
      {children}
    </Slide>
  );
}
export interface AppLayoutProps {
  path?: string;
  mainMenuKey?: string;
  subMenuKey?: string;
  children?: ReactNode;
  sidebar?: React.ComponentType<{
    collapsed: boolean;
    onCollapseChange: () => void;
    user?: UserWithType;
    collapseOnSelect: boolean;
  }>;
}

export const AppLayout = ({
  children,
  sidebar = AppSidebar,
}: AppLayoutProps) => {
  const theme = useTheme();

  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.down("md"));

  const { sidebarCollapsed, toggleSidebarCollapsed } = useAppLayout();

  const isQuickBarShown = isXs;
  const Sidebar = sidebar;

  return (
    <Box position="relative">
      <Sidebar
        collapsed={sidebarCollapsed}
        onCollapseChange={toggleSidebarCollapsed}
        collapseOnSelect={isSm && !isXs}
      />
      <Backdrop
        animate={{ opacity: isSm && !isXs && !sidebarCollapsed ? 0.2 : 1 }}
        style={{ overflowX: "clip" }}
      >
        <Content collapsed={sidebarCollapsed} isMobile={isXs}>
          {children ? children : <Outlet />}
        </Content>
      </Backdrop>
      {isQuickBarShown && (
        <HideOnScroll>
          <Quickbar />
        </HideOnScroll>
      )}
    </Box>
  );
};
